





















import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';

// import { TravelType } from '@targomo/core';
// import { FilterStore } from '@/store/filter';
// import { MapStore } from '@/store/map';
import SelectTravelType from '@/components/SelectTravelType.vue';
import Slider from '@/components/forms/Slider.vue';

@Component({
  components: { SelectTravelType, Slider }
})
export default class WidgetFilter extends Vue {
  @Prop({ required: true }) travelTypeOptions!: ['car', 'transit', 'airplane'];
  @Prop() defaultTravelType!: 'car' | 'transit' | 'airplane';

  @Prop() minTravelTime!: number;
  @Prop() maxTravelTime!: number;
  @Prop() defaultTravelTime!: number;

  travelType: 'car' | 'transit' | 'airplane' = this.defaultTravelType;
  travelEdgeWeightsMin = this.minTravelTime ? this.minTravelTime : 60;
  travelEdgeWeightsMax = this.maxTravelTime ? this.maxTravelTime : 300;
  travelEdgeWeights = this.maxTravelTime;

  disabled = true;

  // private _filterStore!: FilterStore;
  // private _mapStore!: MapStore;

  @Emit()
  change() {
    return !this.disabled;
  }

  created() {
    // this._filterStore = getModule(FilterStore, this.$store);
    // this._mapStore = getModule(MapStore, this.$store);
  }

  travelChange(travelType: 'car' | 'transit' | 'airplane') {
    this.travelType = travelType;
    this.$emit('selected-travel-type', travelType);
  }

  timeChange(time: number) {
    this.travelEdgeWeights = time;
    this.$emit('travel-time', time * 60);
  }
}
